import { IModel } from "./Model";

export interface IGenderModel extends IModel {
    genderId: number;
    name: string;
    rowVersion: string;
}

export class GenderModel implements IGenderModel {
    genderId: number;
    name: string;
    rowVersion: string;

    constructor(params: Partial<IGenderModel> = {} as IGenderModel) {
        const {
            genderId = 0,
            name = "",
            rowVersion = '',
        } = params;

        this.genderId = genderId;
        this.name = name;
        this.rowVersion = rowVersion;
    }
}
